import * as React from 'react'

import { brandName } from '~/client/src/shared/localization/brand'

import { LanguageSelect } from '../LanguageSelect'
import logoUrl from './assets/struxhub-logo.svg?url'

interface IProps {
  title?: React.ReactNode
  description?: React.ReactNode
  showLanguageSelect?: boolean
  children: React.ReactNode
}

export function AuthLayout({
  title,
  description,
  showLanguageSelect,
  children,
}: IProps) {
  return (
    <div className="tw:fixed tw:inset-0 tw:flex tw:flex-col tw:overflow-y-auto tw:bg-background tw:px-4 tw:pt-[env(safe-area-inset-top)] tw:pb-[env(safe-area-inset-bottom)] tw:text-foreground">
      <div className="tw:sticky tw:top-0 tw:z-10 tw:flex tw:h-14 tw:shrink-0 tw:items-center tw:justify-between tw:bg-background">
        <img
          src={logoUrl}
          alt={brandName}
          width={117}
          height={32}
          className="tw:h-7 tw:w-auto"
        />
        {showLanguageSelect && <LanguageSelect />}
      </div>
      <div className="tw:mx-auto tw:flex tw:w-full tw:max-w-sm tw:flex-col tw:gap-6 tw:pt-[10vh] tw:pb-14">
        {(title || description) && (
          <div className="tw:flex tw:flex-col tw:gap-2 tw:text-center">
            {title && (
              <h1 className="tw:m-0 tw:text-app-card-title tw:text-foreground">
                {title}
              </h1>
            )}
            {description && (
              <p className="tw:m-0 tw:text-app-dense tw:text-muted-foreground">
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  )
}
